import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { StatusListQueryKeys } from "modules/StatusListDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { AppointmentStatus } from "models";

type UpdateStatusesPayload = {
  statuses: AppointmentStatus[];
};

export const useUpdateStatusesMutation = () => {
  const { t } = useTranslation();

  return useTypedMutation({
    mutationFn: async (payload: UpdateStatusesPayload) => {
      await ApiInstance.post("/app_statuses/update", payload, ENV.dealerBaseURL);
    },
    onSuccess: ({ statuses }) => {
      typedQueryClient.setQueryData(StatusListQueryKeys.statuses, statuses);
      toast.success(t("v8_updated", "Updated"));
    }
  });
};
